import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import * as ROUTES from '../../../routes';
import './know2.scss';

const useStyles = makeStyles({
  linkStyle: {
    margin: '0 0 0 20px',
    '@media screen and (max-width: 1023px)': {
      margin: 'inherit'
    }
  },
  buttonStyle: {
    minWidth: 384,
    '@media screen and (max-width: 425px)': {
      minWidth: 'inherit',
      fontSize: 20,
      height: 48,
    }
  }
})

const Knows = () => {
  const classes = useStyles()

  const SignUp = () => {
    console.log('Regístrate');
  }

  return (
    <>
      <section className="know2">
        <div className="know2-title">
          <p>Conoce <br/>Contacta Abogado<small>®</small></p>
        </div>
        <div className="know2-wrapper">
          <div className="know2-description">
            <ul>
              <li>
                ¡Regístrate y forma parte de la nueva era del abogado digital!
              </li>
              <li>
                Aprovecha tu tiempo en casa u oficina
              </li>
              <li>
                Obtén clientes potenciales en todo el país
              </li>
            </ul>
            <LinkScroll to="form" smooth="true" duration={1500} offset={-60}>
              <ButtonBase
                onClick={SignUp}
                linkStyle={classes.linkStyle}
                buttonStyle={classes.buttonStyle}
                variant="secondary"
              >
                ¡Regístrate!
              </ButtonBase>
            </LinkScroll>
          </div>
          <div className="know2-image">
            <img
              src="/img/lp-300/web-showcase-project-presentation.png"
              alt=""
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Knows;
